<template>
  <div class="mb-2">
    <div class="tw-flex tw-items-center tw-gap-[12px] tw-justify-end mb-2">
      <search-input
        v-model="search"
        :placeholder="`Cari ${typeTitle} berdasarkan Nama...`"
      />

      <b-button
        variant="primary"
        class="tw-rounded-xl tw-h-[48px]"
        @click="refreshTable()"
      >
        <feather-icon class="mr-1" icon="RefreshCcwIcon" />
        <span class="text-nowrap">Refresh</span>
      </b-button>

      <b-button
        v-b-modal.tambah-product
        variant="primary"
        class="tw-rounded-xl tw-h-[48px]"
      >
        <feather-icon class="mr-1" icon="PlusCircleIcon" />
        <span class="text-sm text-nowrap">Tambah</span>
      </b-button>
    </div>

    <!-- Table Contianer Card -->
    <b-card no-body class="mb-0">
      <b-table
        :busy="isLoading"
        class="position-relative"
        :items="data"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        striped
        hover
        empty-text="Data tidak ditemukan"
      >
        <template #table-busy>
          <div class="my-2 text-center text-danger">
            <b-spinner class="mr-1 align-middle"></b-spinner>
            <strong>Sedang memuat data...</strong>
          </div>
        </template>

        <template #cell(is_active)="data">
          <p>
            {{ !!data.value ? "Aktif" : "Non-aktif" }}
          </p>
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              :to="{ name: `detail-${type}`, params: { id: data.item.id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">Detail Produk</span>
            </b-dropdown-item>

            <b-dropdown-item
              @click="setTargetedId(data.item.id)"
              v-b-modal.edit-product
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              @click="setTargetedId(data.item.id)"
              v-b-modal.hapus-produk
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <pagination
          :currentPage="pagination.currentPage"
          :total="pagination.totalItems"
          @update:currentPage="pagination.currentPage = $event"
        />
      </div>
    </b-card>

    <!-- Add Product -->
    <b-modal
      id="tambah-product"
      size="md"
      centered
      ref="modalProduct"
      title="Tambahkan Product"
      cancel-title="Close"
      :ok-title-html="`${isLoadingSubmit ? 'Loading..' : 'Save'}`"
      no-close-on-backdrop
      no-close-on-esc
      :ok-disabled="isLoadingSubmit"
      :cancel-disabled="isLoadingSubmit"
      :hide-header-close="isLoadingSubmit"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitProduct"
    >
      <b-form>
        <b-form-group label="Nama Produk" label-for="nama">
          <b-form-input
            v-model="formProduct.nama"
            id="nama"
            placeholder="Masukkaan Nama Produk"
          />
        </b-form-group>
        <b-form-group label="Nama Jenis" label-for="jenis">
          <v-select
            v-model="formProduct.jenis"
            id="jenis"
            label="nama"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="listJenis"
            :reduce="(jenis) => jenis.kode"
          />
        </b-form-group>

        <b-form-group label="Kategori" label-for="category">
          <v-select
            v-model="formProduct.category"
            id="category"
            label="title"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="listKategoriTryout"
            :reduce="(category) => category.kode"
          />
        </b-form-group>

        <b-form-group label="Label" label-for="label">
          <b-form-input
            v-model="formProduct.label"
            id="label"
            placeholder="Masukkaan Label Produk"
          />
        </b-form-group>

        <b-form-group
          v-if="formProduct.jenis === 'PREMIUM'"
          label="Harga"
          label-for="harga"
        >
          <b-form-input
            v-model="formProduct.harga"
            id="harga"
            type="number"
            min="0"
            placeholder="Masukkaan Harga Produk"
          />
        </b-form-group>

        <b-form-group
          v-if="formProduct.jenis === 'PREMIUM'"
          label="Harga Diskon"
          label-for="hargaDiskon"
        >
          <b-form-input
            v-model="formProduct.harga_diskon"
            id="hargaDiskon"
            type="number"
            min="0"
            placeholder="Masukkaan Harga Diskon Produk"
          />
        </b-form-group>

        <div class="tw-flex tw-items-center tw-gap-3">
          <label for="show">Aktif</label>
          <b-form-checkbox
            v-model="formProduct.is_active"
            :checked="formProduct.is_active"
            switch
            id="show"
            name="check-button"
          />
        </div>
      </b-form>
    </b-modal>

    <!-- Edit Product -->
    <b-modal
      id="edit-product"
      size="md"
      centered
      title="Edit Product"
      cancel-title="Close"
      :ok-title-html="`${isLoadingSubmit ? 'Loading..' : 'Save'}`"
      no-close-on-backdrop
      no-close-on-esc
      :ok-disabled="isLoadingSubmit"
      :cancel-disabled="isLoadingSubmit"
      :hide-header-close="isLoadingSubmit"
      cancel-variant="outline-secondary"
      @show="fetchProduct"
      @hidden="resetModal"
      @ok="editProduct"
    >
      <b-form>
        <b-form-group label="Nama Produk" label-for="nama">
          <b-form-input
            v-model="formProduct.nama"
            id="nama"
            placeholder="Masukkaan Nama Produk"
          />
        </b-form-group>
        <b-form-group label="Nama Jenis" label-for="jenis">
          <v-select
            v-model="formProduct.jenis"
            id="jenis"
            label="nama"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="listJenis"
            :reduce="(jenis) => jenis.kode"
          />
        </b-form-group>

        <b-form-group label="Kategori" label-for="category">
          <v-select
            id="category"
            v-model="formProduct.category"
            label="title"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="listKategoriTryout"
            :reduce="(category) => category.kode"
          />
        </b-form-group>

        <b-form-group label="Label" label-for="label">
          <b-form-input
            v-model="formProduct.label"
            id="label"
            placeholder="Masukkaan Label Produk"
          />
        </b-form-group>

        <b-form-group
          v-if="formProduct.jenis === 'PREMIUM'"
          label="Harga"
          label-for="harga"
        >
          <b-form-input
            v-model="formProduct.harga"
            id="harga"
            type="number"
            min="0"
            placeholder="Masukkaan Harga Produk"
          />
        </b-form-group>

        <b-form-group
          v-if="formProduct.jenis === 'PREMIUM'"
          label="Harga Diskon"
          label-for="hargaDiskon"
        >
          <b-form-input
            v-model="formProduct.harga_diskon"
            id="hargaDiskon"
            type="number"
            min="0"
            placeholder="Masukkaan Harga Diskon Produk"
          />
        </b-form-group>

        <div class="tw-flex tw-items-center tw-gap-3">
          <label for="show">Aktif</label>
          <b-form-checkbox
            v-model="formProduct.is_active"
            :checked="formProduct.is_active"
            switch
            id="show"
            name="check-button"
          />
        </div>
      </b-form>
    </b-modal>

    <!-- Delete product -->
    <b-modal
      id="hapus-produk"
      cancel-variant="outline-secondary"
      :ok-title-html="`${isLoadingSubmit ? 'Loading..' : 'Save'}`"
      no-close-on-backdrop
      no-close-on-esc
      :ok-disabled="isLoadingSubmit"
      :cancel-disabled="isLoadingSubmit"
      :hide-header-close="isLoadingSubmit"
      cancel-title="Close"
      centered
      title="Hapus Produk"
      @ok="deleteProduct"
    >
      <b-form>
        <b-form-group>
          <p>Apakah anda akan menghapus Produk ini?</p>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
} from "@vue/composition-api";
import {
  BButton,
  BCard,
  BTable,
  BSpinner,
  BDropdown,
  BDropdownItem,
  BModal,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
} from "bootstrap-vue";
import { useAppToast } from "@/@core/utils/toast";
import { formatDate, rupiah } from "@core/utils/utils";
import SearchInput from "@/@core/components/base/SearchInput.vue";
import Pagination from "@/@core/components/base/Pagination.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

import debounce from "lodash.debounce";
import vSelect from "vue-select";

import repository from "@repofactory";
import router from "@/router";
const repoJenis = repository.get("JenisRepository");
const repoKategori = repository.get("kategoriSoalRepository");
const repoProducts = repository.get("ProductsRepository");

const TYPE_MAP = {
  ebook: "Ebook",
  video: "Video",
  materi_dokumen: "Materi Dokumen",
  kelas_live: "Live",
  community: "Komunitas",
};

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) =>
        [
          "ebook",
          "video",
          "materi_dokumen",
          "kelas_live",
          "community",
        ].includes(value),
    },
  },
  components: {
    BButton,
    BCard,
    BTable,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BModal,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    SearchInput,
    Pagination,
    FeatherIcon,
    vSelect,
  },
  setup(props) {
    // ----- SCOPE GENERAL ----- //
    const { showToast } = useAppToast();
    const typeTitle = computed(() => TYPE_MAP[props.type]);

    const fetchJenis = async () => {
      try {
        const res = await repoJenis.get();
        listJenis.value = res.data.data;
      } catch (e) {
        listJenis.value = [
          {
            id: 1,
            kode: "PREMIUM",
            nama: "PREMIUM",
          },
          {
            id: 2,
            kode: "GRATIS",
            nama: "GRATIS",
          },
        ];
      }
    };

    const fetchKategoriTryout = async () => {
      await repoKategori
        .get({ page: 1, page_size: 1000 })
        .then((response) => {
          listKategoriTryout.value = response.data.data.data.map((val) => {
            return {
              id: val.id,
              title: val.nama.toUpperCase(),
              kode: val.kode.toUpperCase(),
            };
          });
        })
        .catch((error) => {
          if (error.response) {
            showToast(
              "Error",
              error.response.data.message,
              "danger",
              "AlertTriangleIcon"
            );
          } else if (error.request) {
            showToast(
              "Error",
              "Tidak bisa request data ke server",
              "danger",
              "AlertTriangleIcon"
            );
          } else {
            showToast("Error", error.message, "danger", "AlertTriangleIcon");
          }
        });
    };
    // ----- SCOPE GENERAL ----- //

    // ----- SCOPE TABLE ----- //
    const tableColumns = [
      { key: "id", label: "ID" },
      { key: "nama", label: "NAMA" },
      { key: "category", label: "KATEGORI" },
      { key: "jenis", label: "JENIS" },
      { key: "label", label: "LABEL" },
      {
        key: "harga",
        label: "HARGA",
        formatter: (value) => {
          return rupiah(value);
        },
      },
      {
        key: "harga_diskon",
        label: "HARGA DISKON",
        formatter: (value) => {
          return rupiah(value);
        },
      },
      {
        key: "created_at",
        label: "DIBUAT",
        formatter: (value) => {
          return formatDate(value);
        },
      },
      {
        key: "updated_at",
        label: "DIUBAH",
        formatter: (value) => {
          return formatDate(value);
        },
      },
      { key: "is_active", label: "STATUS" },
      { key: "actions" },
    ];

    const data = ref([]);
    const isLoading = ref(false);

    const listJenis = ref([]);
    const listKategoriTryout = ref([]);

    const search = ref("");
    const pagination = ref({
      currentPage: 1,
      totalItems: 0,
    });

    const fetchData = async (page = 1, search = "") => {
      isLoading.value = true;
      try {
        const res = await repoProducts.get({ page, search, type: props.type });
        pagination.value.currentPage = res.data.data.current_page;
        pagination.value.totalItems = res.data.data.total_items;
        data.value = res.data.data.data;
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Fetching data products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      } finally {
        isLoading.value = false;
      }
    };

    const refreshTable = async () => {
      isLoading.value = true;
      await fetchData(pagination.value.currentPage, search.value);
      isLoading.value = false;
    };

    onMounted(async () => {
      await Promise.all([fetchData(), fetchJenis(), fetchKategoriTryout()]);
    });

    watch(
      () => search.value,
      debounce(() => {
        fetchData(1, search.value);
      }, 500)
    );

    watch(
      () => pagination.value.currentPage,
      (val) => {
        fetchData(val, search.value);
      }
    );
    // ----- SCOPE TABLE ----- //

    // ----- SCOPE FORM ----- //
    const modalProduct = ref(null);
    const modalAddDetails = ref(null);
    const isLoadingSubmit = ref(false);
    const product_id = ref(null);
    const setTargetedId = (value) => {
      product_id.value = value;
    };

    const formProduct = ref({
      nama: "",
      label: "",
      jenis: "",
      category: "",
      product_type: props.type,
      harga: 0,
      harga_diskon: 0,
      is_active: false,
    });

    const resetModal = () => {
      formProduct.value = {
        nama: "",
        label: "",
        jenis: "",
        category: "",
        product_type: props.type,
        harga: 0,
        harga_diskon: 0,
        is_active: false,
      };
    };

    const fetchProduct = async () => {
      try {
        const res = await repoProducts.getDetail(product_id.value);
        const data = res.data.data;
        formProduct.value = {
          ...formProduct.value,
          nama: data.nama,
          category: data.category,
          jenis: data.jenis,
          harga: data.harga,
          harga_diskon: data.harga_diskon,
          label: data.label,
          is_active: !!data.is_active,
        };
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Fetching data product",
            "danger",
            "AlertTriangleIcon"
          );
        }
      }
    };

    const getFormData = (payload) => {
      let formData = new FormData();
      const { nama, label, jenis, category, harga, harga_diskon, is_active } =
        payload;
      formData.append("nama", nama);
      formData.append("label", label);
      formData.append("jenis", jenis);
      formData.append("category", category);
      formData.append("harga", harga);
      formData.append("harga_diskon", harga_diskon);
      formData.append("is_active", is_active);

      return formData;
    };

    const validatePrice = (payload) => {
      if (payload.jenis !== "PREMIUM") {
        return true;
      }

      const harga = Number(payload.harga || 0);
      const hargaDiskon = Number(payload.harga_diskon || 0);

      if (harga < hargaDiskon) {
        showToast(
          "Error",
          "Harga tidak boleh lebih rendah dari harga diskon",
          "danger",
          "AlertTriangleIcon"
        );
        return false;
      }

      return true;
    };

    const submitProduct = async (bvModalEvent) => {
      isLoadingSubmit.value = true;
      bvModalEvent.preventDefault();

      if (!validatePrice(formProduct.value)) {
        isLoadingSubmit.value = false;
        return;
      }

      try {
        const res = await repoProducts.create(getFormData(formProduct.value));
        product_id.value = res.data.data.id;

        showToast("Notifikasi", res.data.message, "primary");
        modalProduct.value.hide();
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Submit data products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      } finally {
        isLoadingSubmit.value = false;
        router.push({
          name: `detail-${props.type}`,
          params: { id: product_id.value },
        });
      }
    };

    const editProduct = async (bvModalEvent) => {
      isLoadingSubmit.value = true;
      bvModalEvent.preventDefault();

      if (!validatePrice(formProduct.value)) {
        isLoadingSubmit.value = false;
        return;
      }

      try {
        const res = await repoProducts.update(
          product_id.value,
          getFormData(formProduct.value)
        );

        bvModalEvent.vueTarget.hide();
        showToast("Notifikasi", res.data.message, "primary");
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Edit data products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      } finally {
        isLoadingSubmit.value = false;
        fetchData();
      }
    };

    const deleteProduct = async (modal) => {
      isLoadingSubmit.value = true;
      modal.preventDefault();

      try {
        const res = await repoProducts.delete(product_id.value);
        showToast("Notifikasi", res.data.message, "primary");
        modal.vueTarget.hide();
        fetchData();
      } catch (e) {
        if (e.response.data.message) {
          showToast(
            "Error",
            e.response.data.message,
            "danger",
            "AlertTriangleIcon"
          );
        } else {
          showToast(
            "Error",
            "Error Submit data products",
            "danger",
            "AlertTriangleIcon"
          );
        }
      } finally {
        isLoadingSubmit.value = false;
      }
    };
    // ----- SCOPE FORM ----- //

    return {
      typeTitle,
      tableColumns,
      data,
      isLoading,
      search,
      pagination,
      refreshTable,

      modalProduct,
      modalAddDetails,
      listJenis,
      listKategoriTryout,
      product_id,
      formProduct,
      isLoadingSubmit,

      setTargetedId,
      resetModal,
      fetchProduct,
      submitProduct,
      editProduct,
      deleteProduct,
    };
  },
});
</script>
